import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// Iconsax, matching the mapping already established for the LeftNav rail
// (Contacts -> Profile2User, Broadcast -> Radio).
import { Profile2User, Radio } from "iconsax-react";
import PanelHeading, { SUBTITLE_HEIGHT } from "../Navbar/PanelHeading";
import SidebarNavList from "../Navbar/SidebarNavList";

// description is used by Reports.jsx's content-header subtitle, so the
// sidebar icon and the header icon/description share one source of truth.
export const REPORT_TABS = [
  { key: "teamMembers", label: "Team Members", icon: Profile2User, description: "See how each team member is performing." },
  { key: "broadcasts", label: "Broadcasts", icon: Radio, description: "Track delivery and engagement for your broadcasts." },
];

// Rebuilt 2026-09-10 to match Inbox's rail exactly (same shared components as
// Settings' own sidebar) -- was its own hand-rolled ListItemButton list with a
// left-border accent instead of Inbox's background-only selection.
const ReportsSidebar = ({ selectedTab, onSelectTab, broadcastsAllowed = true }) => {
  const theme = useTheme();

  // Phase 6 ("Client UI") QR gating — Broadcasts can never have data for a QR-connected
  // workspace (Bulk Campaigns are 100% template-gated, blocked for QR at the data-model level),
  // so the tab itself is hidden rather than shown empty.
  const visibleTabs = broadcastsAllowed ? REPORT_TABS : REPORT_TABS.filter((t) => t.key !== "broadcasts");

  const items = visibleTabs.map((tab) => {
    const selected = selectedTab === tab.key;
    const Icon = tab.icon;
    return {
      key: tab.key,
      label: tab.label,
      selected,
      onClick: () => onSelectTab(tab.key),
      icon: (
        <Icon
          size="100%"
          color={selected ? theme.palette.text.primary : "currentColor"}
          variant={selected ? "Bold" : "Linear"}
        />
      ),
    };
  });

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "280px" },
        flexShrink: 0,
        height: { xs: "auto", sm: "100%" },
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "background.default",
        borderRight: (theme) => ({ xs: "none", sm: `1px solid ${theme.palette.divider}` }),
        borderBottom: (theme) => ({ xs: `1px solid ${theme.palette.divider}`, sm: "none" }),
      }}
    >
      {/* Forced to the same fixed height as the content pane's header (which has
          a subtitle, this one doesn't) so the two bottom border lines land on
          the same pixel -- same fix as Settings' sidebar header. No xs special
          case needed: Reports.jsx stacks the sidebar above the content at xs
          (flexDirection:"column"), not side-by-side, so there's no second
          header to align with there. */}
      <PanelHeading title="Reports" variant="narrow" sx={{ height: SUBTITLE_HEIGHT }} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <SidebarNavList items={items} />
      </Box>
    </Box>
  );
};

export default ReportsSidebar;
